import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import StickyMobileCta from "@/components/site/StickyMobileCta";
import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";

export default function PublicLayout() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <StickyMobileCta />
    </div>
  );
}
